import { useEffect, useLayoutEffect } from "react";
// const isBrowser = typeof document !== undefined;

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
